import { useState } from 'react';
import { Link } from 'react-router-dom';
import api from '../services/api';

export default function ForgotPasswordPage() {
  const [email, setEmail] = useState('');
  const [submitted, setSubmitted] = useState(false);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError('');
    try {
      await api.forgotPassword(email);
      setSubmitted(true);
    } catch (err) {
      setError(err.message || 'Something went wrong. Please try again.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="login-page">
      <div className="login-card">
        <div className="login-header">
          <h1 className="login-logo">Stellar<span>Reply</span></h1>
        </div>

        {submitted ? (
          <div style={{ textAlign: 'center', padding: '20px 0' }}>
            <div style={{ fontSize: '48px', marginBottom: '16px' }}>✉️</div>
            <h2 style={{ fontSize: '20px', fontWeight: '600', marginBottom: '8px' }}>Check your email</h2>
            <p style={{ fontSize: '14px', color: 'var(--text-light)', marginBottom: '24px', lineHeight: '1.6' }}>
              If an account exists with <strong>{email}</strong>, we've sent a link to reset your password. 
              The link expires in 1 hour.
            </p>
            <p style={{ fontSize: '13px', color: 'var(--text-light)' }}>
              Didn't receive it? Check your spam folder or{' '}
              <button 
                onClick={() => setSubmitted(false)} 
                style={{ 
                  background: 'none', border: 'none', color: 'var(--primary)', 
                  cursor: 'pointer', fontSize: '13px', textDecoration: 'underline' 
                }}
              >
                try again
              </button>
            </p>
            <Link to="/login" className="btn btn-secondary" style={{ marginTop: '20px', display: 'inline-block' }}>
              Back to login
            </Link>
          </div>
        ) : (
          <>
            <h2 style={{ fontSize: '20px', fontWeight: '600', marginBottom: '4px', textAlign: 'center' }}>
              Reset your password
            </h2>
            <p style={{ fontSize: '14px', color: 'var(--text-light)', textAlign: 'center', marginBottom: '24px' }}>
              Enter your email and we'll send you a reset link.
            </p>

            {error && (
              <div style={{
                padding: '12px', marginBottom: '16px',
                background: '#fef2f2', border: '1px solid #ef4444',
                borderRadius: '8px', fontSize: '14px', color: '#ef4444',
              }}>
                {error}
              </div>
            )}

            <form onSubmit={handleSubmit}>
              <div className="form-field">
                <label htmlFor="email">Email address</label>
                <input
                  id="email"
                  type="email"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  placeholder="you@example.com"
                  required
                  autoFocus
                />
              </div>

              <button
                type="submit"
                className="btn btn-primary"
                disabled={loading}
                style={{ width: '100%', padding: '12px', marginTop: '8px' }}
              >
                {loading ? 'Sending...' : 'Send reset link'}
              </button>
            </form>

            <p style={{ textAlign: 'center', marginTop: '20px', fontSize: '14px' }}>
              <Link to="/login" style={{ color: 'var(--primary)', textDecoration: 'none' }}>
                Back to login
              </Link>
            </p>
          </>
        )}
      </div>
    </div>
  );
}
